export default "__VITE_ASSET__DvzZtfZI__"